export const constants = {
  summaryTracking: {
    legis: [
      'Total Bills Tracked',
      'Tracked Bills Enacted',
      'Tracked Bills Defeated'
    ],
    regs: [
      'Total Tracked Regulations',
      'Tracked Regulations Approved',
      'Tracked Regulations Abandoned/Closed'
    ],
    local: [
      'Total Items Tracked',
      'Total Ordinances Adopted',
      'Total Ordinances Rejected'
    ]
  },
  subjectBreakdown: {
    titles: {
      legis: [
        {
          title: 'Subjects',
          className: 'wide'
        },
        {
          title: 'Total Bills Introduced',
          className: 'small'
        },
        {
          title: 'Introducing States',
          className: 'wide'
        },
        {
          title: 'Total Bills Enacted',
          className: 'small'
        },
        {
          title: 'Enacting States',
          className: 'wide'
        }
      ],
      regs: [
        {
          title: 'Issue',
          className: 'wide'
        },
        {
          title: 'States With Tracked Regulations',
          className: 'small'
        },
        {
          title: 'Total Regulations',
          className: 'small'
        },
        {
          title: 'Approved Regulations',
          className: 'small'
        }
      ],
      local: [
        {
          title: 'Issue',
          className: 'wide'
        },
        {
          title: 'States With Tracked Regulations',
          className: 'small'
        },
        {
          title: 'Total Regulations',
          className: 'small'
        },
        {
          title: 'Approved Regulations',
          className: 'small'
        }
      ]
    },
    classNames: {
      legis: ['wide', 'small', 'wide', 'small', 'wide'],
      regs: ['wide', 'small', 'small', 'small'],
      local: ['wide', 'small', 'small', 'small']
    }
  },
  stateBreakdown: {
    legis: ['State', 'Total Bills Introduced', 'Total Bills Enacted'],
    regs: ['State', 'Approved', 'Total'],
    local: ['Locality', 'Approved', 'Total']
  },
  nodesData: {
    legis: {
      summaryTracking: 'Legislative Tracking',
      subjectBreakdown: 'Subject Breakdown',
      stateBreakdown: 'State Breakdown'
    },
    regs: {
      summaryTracking: 'Regulations',
      subjectBreakdown: 'Tracked Issue Breakdown',
      stateBreakdown: 'State Breakdown'
    },
    local: {
      summaryTracking: 'Local Tracking',
      subjectBreakdown: 'Items Per Subject',
      stateBreakdown: 'Items Per Locality'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ManagementTrackingStats/constants.js